export default __webpack_public_path__ + "static/media/grid11.c6b0a5dd.png";